import React from 'react';
// import ReactDOM from 'react-dom';
import { render } from 'react-snapshot';
import { createTranslator } from '@/modules/i18n';
import App from './App';

//import * as serviceWorker from './serviceWorker';

createTranslator().then(res => {
  // render(
  //   <App/>,
  //   document.getElementById('root')
  // );
})

render(
  <App/>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
